import { render } from "./InspectionBefore.vue?vue&type=template&id=84b29f88"
import script from "./InspectionBefore.vue?vue&type=script&lang=js"
export * from "./InspectionBefore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/InspectionBefore.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "84b29f88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('84b29f88', __exports__)) {
    api.reload('84b29f88', __exports__)
  }
  
  module.hot.accept("./InspectionBefore.vue?vue&type=template&id=84b29f88", () => {
    api.rerender('84b29f88', render)
  })

}


export default __exports__